import React, { useState } from 'react';
import PropTypes from 'prop-types';
import autocompleteSearch from './autocomplete';

const SearchBar = ({ searchData, name }) => {
  const [addSuggest, setAddSuggest] = useState(true);

  const handleSuggestions = (e) => {
    if (addSuggest) {
      autocompleteSearch(searchData, e.target, name);
      setAddSuggest(false);
    }
  };

  return (
    <input
      type="text"
      id="autoComplete"
      placeholder="Buscar"
      onClick={(e) => handleSuggestions(e)}
      autoComplete="off"
      name={name}
    />
  );
};

SearchBar.propTypes = {
  searchData: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
};

export default SearchBar;
